import React, { useState } from 'react';
import { Link } from '../../Link/Link';
import { Logo } from '../../Logo/Logo';
import { Paragraph } from '../../Paragraph/Paragraph';
import { CountDown } from '../../CountDown/CountDown';
import { GameGraphics } from '../../GameGraphics/GameGraphics';
import { GameActions } from '../../TileActions/GameActions';
import type { TileProps } from '../tiles';
import { GAME_UNAVAILABLE } from '../../../helpers/tileHelper';
import { track } from '../../../helpers/tracking';
import { isMobile, isTablet } from '@SharedScripts/Utils/DeviceClass';

export const MicroTile = ({
  title,
  type,
  gameGraphics,
  navigationUrl,
  navigationUrlWithLaunchParam,
  openFrom,
  isTableClosed,
  isUnavailable,
  className,
  onClick,
  tabIndex,
}: TileProps) => {
  const [graphicsLoading, setGraphicsLoading] = useState(true);
  const [graphicsError, setGraphicsError] = useState(false);

  const linkAriaLabel = `Start spil ${title}`;

  const graphicsDisabled =
        isUnavailable || (type !== 'Casino' && isTableClosed);

  const shouldRenderLogo = (graphicsError && !graphicsDisabled) || !gameGraphics?.backgroundUrl;

  return (
    <article
      data-tracking-meta-data={JSON.stringify({
        tileType: 'Micro',
        action: isMobile() || isTablet() ? 'click game tile' : 'game open',
        label: isMobile() || isTablet() ? 'mobile' : 'desktop',
      })}
      onClick={onClick}
      className={`group relative flex rounded-32 p-8 !size-fit
            bg-transparent hover:bg-neutrals-white/50 transition-all duration-300 ease-in-out ${className}`}
    >

      <div onClick={track}>
        <Link
          className='absolute top-0 right-0 bottom-0 left-0 focus-visible:ring-primary rounded-24 z-20'
          href={navigationUrl}
          ariaLabel={linkAriaLabel}
          disabled={isUnavailable || !navigationUrl}
          tabIndex={tabIndex}
        />
      </div>

      <div className='relative h-full flex aspect-square size-80 md:size-96'>
        <GameGraphics
          {...gameGraphics}
          imageWidth={100}
          isLoading={graphicsLoading}
          onLoaded={() => setGraphicsLoading(false)}
          onError={() => setGraphicsError(true)}
          error={graphicsError}
          lazyLoad={true}
          disabled={graphicsDisabled}
          useDarkGradient={type === 'Live' && !isUnavailable}
          useLogoAsForeground={true}
          className={`overflow-hidden ${type === 'Live' ? 'bg-gradient-to-t from-neutrals-grey-950/80 to-neutrals-grey-950/80' : ''}`}
          rounded='rounded-24'
          backgroundStyle={type === 'Live' ? 'object-top opacity-50' : ''}
        />

        {!isUnavailable && (
          <GameActions
            href={navigationUrlWithLaunchParam}
            linkAriaLabel={linkAriaLabel}
            className='is-desktop-detected:opacity-0 is-desktop-detected:group-hover:opacity-100 z-20 m-auto
                            is-desktop-detected:group-focus-within:opacity-100 is-desktop-detected:group-focus:opacity-100 transition-opacity duration-300 ease-in-out'
            tabIndex={tabIndex}
            isTableClosed={isTableClosed}
          />
        )}

        {shouldRenderLogo && (
          <div className='absolute h-full w-full flex flex-col justify-center align-center'>
            <Logo className='w-24 z-10  mx-auto' />
          </div>
        )}


        {!isUnavailable && isTableClosed && (
          <CountDown
            className='relative my-auto text-white w-full text-center text-14 px-8'
            openingTime={openFrom ?? ''}
            openingTimeLabel='Åbner om'
          />
        )}

        {isUnavailable && (
          <Paragraph
            size={10}
            weight='bold'
            truncate={2}
            className='relative self-center text-center my-auto max-w-[20ch] text-neutrals-grey-950'
          >
            {GAME_UNAVAILABLE}
          </Paragraph>
        )}

      </div>

    </article>
  );
};
